module.exports = __webpack_public_path__ + "img/npc-round-logo.13286770.png";